import * as React from 'react';

import DomainPillItem from 'bundles/page-config-common/components/shared/DomainPillItem';
import DomainPillsModule from 'bundles/page-config-common/components/shared/DomainPillsModule';
import HomeSection from 'bundles/page-config-common/components/shared/HomeSection';
import SubdomainText from 'bundles/page-config-common/components/shared/SubdomainText';
import { useDomainPills } from 'bundles/page-config-common/contexts/DomainsPillsContext';
import { useProgram } from 'bundles/unified-common/contexts/EnterpriseProgramContext';

import _t from 'i18n!nls/consumer-home';

const EnterpriseDomainPillsModuleRenderer = () => {
  const { domains } = useDomainPills();
  const program = useProgram();

  if (domains?.length) {
    const programSlug = program?.metadata.slug;

    return (
      <HomeSection className="PageConfig_DomainPillsComponent">
        <DomainPillsModule
          title={_t('Categories')}
          domainPillItems={domains?.map((domainPill, index) => (
            <DomainPillItem
              index={index}
              key={domainPill.id}
              id={domainPill.id}
              name={domainPill.name}
              url={`/programs/${programSlug}/${domainPill.id}`}
              subdomain={<SubdomainText subdomains={domainPill.subdomains} />}
            />
          ))}
        />
      </HomeSection>
    );
  } else {
    return null;
  }
};

export default EnterpriseDomainPillsModuleRenderer;
